module.exports = __webpack_public_path__ + "assets/img/5_1292_big.925e9ec4.jpg";